import React from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Form,Input,Radio,Icon,Button,message,Popover } from 'antd';
import LoadingCover from 'components/LoadingCover';
import abortAjaxHoc from 'components/abortAjaxHoc';
import {mixObj} from 'utils/tool';
import style from './Compare.module.less';
import classnames from 'classnames';
const FormItem = Form.Item;
const LabelMap = {
    'security_level':{
        label:'Compare strictness',
        dec:'The stricter the standards, the higher the detection rate, and the lower the corresponding pass rate.'
    },
    'fail_when_multiple_faces':{
        label:'Whether to compare multiple faces',
        dec:'When selecting comparison, when there are multiple faces in the uploaded photo, the largest face in the picture will be taken for subsequent verification; when no comparison is selected, if the above situation occurs, an error code will be returned directly'
    },
    'face_quality_threshold':{
        label:'Face quality threshold in uploaded photos（0-100）',
        dec:'The threshold value of the face image quality score in the "photo to be compared" (the one with the largest face area), the higher the threshold, the higher the requirement for the clarity of the face in the "photo to be compared"'
    },
    'return_faces':{
        label:'Whether to return the face verification result',
        dec:'When "Yes" is selected, the face verification result (including face quality, face quality threshold, face coordinate points and face direction) will be returned . When "No" is selected, the face verification result will not be returned'
    },
    'verify_risk_detect':{
        label:'Whether to enable verify risk detection',
        dec:'When turned on, the verify risk info is returned'
    },
    'multi_oriented_detection':{
        label:'Whether to enable rotation detection',
        dec:'When it is turned on, when the face cannot be detected, it will rotate 90 degrees, 180 degrees, 270 degrees and continue to detect'
    }
};

class CompareForm extends React.Component {

    constructor(props){
        super(props);
        this.id = props.id; //存在id为编辑模式
        this.mode = this.id === undefined ?'create':'edit';
        this.cacheValues = {};
        this.state = {
            isShowMore:false,
            readOnly:false,
            loading:this.mode === 'edit'
        };
    }

    componentDidMount(){
        if(this.mode === 'edit'){
            this.props.abortableAjax('GET','/compare_scene/'+this.id).then(res=>{
                //先设置场景类型
                const readOnly = res.data.state === 'default';
                this.setState({readOnly},()=>{

                    //获取现有表单数据
                    const {getFieldsValue,setFieldsValue} = this.props.form;
                    const values = getFieldsValue();
                    //取values存在的字段
                    const newValues = mixObj(values,res.data);
                    //表单回填
                    setFieldsValue(newValues,()=>{
                        this.setState({loading:false});
                    });

                });
            });
        }
    }

    onSave = ()=>{
        let url = '/compare_scene';
        let type = 'put';
        if(this.id){
            url = '/compare_scene/'+this.id;
            type = 'post';
        }
        this.props.form.validateFields((errors, values)=>{
            if(!errors){
                this.setState({loading:true});
                values['face_quality_threshold'] = parseInt(values['face_quality_threshold']);
                this.props.abortableAjax(type,url,values).then(()=>{
                    message.success('Successful operation');
                    this.props.history.push('/pages/compare-scenes');
                }).catch(()=>{
                    this.setState({loading:false});
                });
            }
        });
    }

    getLabel = (key)=>{
        const textMap = LabelMap[key];
        if(!textMap) return;
        return <div className={style.labelBox}>
            <span className={style.label}>{textMap.label}</span>
            {textMap.dec && (
                <Popover
                    placement="right"
                    content={<div className={style.dec}>{textMap.dec}</div>}
                >
                    <Icon className={style.icon} type="info-circle" theme="filled" />
                </Popover>
            )}
        </div>;
    }

    onShowMore = ()=>{
        this.setState({isShowMore:!this.state.isShowMore});
    }

    setDisabled(){
        return this.state.readOnly;
    }

    render(){
        const {getFieldDecorator} = this.props.form;
        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 }
        };
        const moreClass = classnames({
            [style.moreBox]:true,
            [style.show]:this.state.isShowMore
        });
        return (
            <div style={{marginTop:20}}>
                <LoadingCover spinning={this.state.loading}>
                    <Form layout="vertical">
                        <FormItem label="Scenes Name" {...formItemLayout}>
                            {getFieldDecorator('name',{
                                rules:[
                                    {required:true,message:'not nullable'},
                                    {max:20,message:'Cannot be greater than 20 characters'}
                                ]
                            })(
                                <Input placeholder="Cannot be greater than 20 characters" disabled={this.setDisabled('name')}/>
                            )}
                        </FormItem>
                        <FormItem label="Scenes Describe" {...formItemLayout}>
                            {getFieldDecorator('description',{
                                rules:[
                                    {max:50,message:'Cannot be greater than 50 characters'}
                                ]
                            })(
                                <Input placeholder="Cannot be greater than 50 characters" disabled={this.setDisabled('description')}/>
                            )}
                        </FormItem>
                        <div className={style.line}></div>
                        <h1 className={style.title}>compare config</h1>
                        <FormItem colon={false} label={this.getLabel('security_level')} >
                            {getFieldDecorator('security_level',{
                                initialValue:2,
                                rules:[
                                    {required:true,message:'not nullable'}
                                ]
                            })(
                                <Radio.Group disabled={this.setDisabled('security_level')}>
                                    <Radio value={1}>loose</Radio>
                                    <Radio value={2}>conventional</Radio>
                                    <Radio value={3}>strict</Radio>
                                    <Radio value={4}>very strict</Radio>
                                </Radio.Group>
                            )}
                        </FormItem>

                        <div className={style.moreButtonBox}>
                            <span className={style.more} onClick={this.onShowMore}>More advanced settings</span>
                            <Icon className={style.moreArrow} type="down" /><Icon className={style.icon} type="info-circle" theme="filled" />
                            <span className={style.moreDec}>Advanced configuration adjustment suggestions are operated under your exclusive business guidance</span>
                        </div>
                        <div className={moreClass}>
                            <FormItem colon={false} label={this.getLabel('fail_when_multiple_faces')} >
                                {getFieldDecorator('fail_when_multiple_faces',{
                                    initialValue:0,
                                    rules:[
                                        {required:true,message:'not nullable'}
                                    ]
                                })(
                                    <Radio.Group disabled={this.setDisabled('fail_when_multiple_faces')}>
                                        <Radio value={0}>compare</Radio>
                                        <Radio value={1}>don't compare</Radio>
                                    </Radio.Group>
                                )}
                            </FormItem>
                            <FormItem colon={false} label={this.getLabel('face_quality_threshold')} >
                                {getFieldDecorator('face_quality_threshold',{
                                    initialValue:'30',
                                    validateFirst:true,
                                    rules:[
                                        {required:true,message:'not nullable'},
                                        {pattern:/^([1-9]\d*|0)$/,message:'please enter a number between 0 and 100'},
                                        {validator:(rule, value, callback)=>{
                                            const num = parseInt(value);
                                            if( num<0 || num>100){
                                                callback('please enter a number between 0 and 100');
                                            }else{
                                                callback();
                                            }
                                        }}
                                    ]
                                })(
                                    <Input disabled={this.setDisabled('face_quality_threshold')} style={{width:200}}/>
                                )}
                            </FormItem>

                            <FormItem colon={false} label={this.getLabel('return_faces')} >
                                {getFieldDecorator('return_faces',{
                                    initialValue:1,
                                    rules:[
                                        {required:true,message:'not nullable'}
                                    ]
                                })(
                                    <Radio.Group disabled={this.setDisabled('return_faces')}>
                                        <Radio value={1}>yes</Radio>
                                        <Radio value={0}>no</Radio>
                                    </Radio.Group>
                                )}
                            </FormItem>
                            <FormItem colon={false} label={this.getLabel('multi_oriented_detection')} >
                                {getFieldDecorator('multi_oriented_detection',{
                                    initialValue:1,
                                    rules:[
                                        {required:true,message:'not nullable'}
                                    ]
                                })(
                                    <Radio.Group disabled={this.setDisabled('multi_oriented_detection')}>
                                        <Radio value={1}>yes</Radio>
                                        <Radio value={0}>no</Radio>
                                    </Radio.Group>
                                )}
                            </FormItem>
                            <FormItem colon={false} label={this.getLabel('verify_risk_detect')} >
                                {getFieldDecorator('verify_risk_detect',{
                                    initialValue:0,
                                    rules:[
                                        {required:true,message:'not nullable'}
                                    ]
                                })(
                                    <Radio.Group disabled={this.setDisabled('verify_risk_detect')}>
                                        <Radio value={1}>yes</Radio>
                                        <Radio value={0}>no</Radio>
                                    </Radio.Group>
                                )}
                            </FormItem>
                        </div>

                    </Form>
                    <div>
                        {!this.state.readOnly && <Button type="primary" style={{marginRight:24}} onClick={this.onSave} loading={this.state.loading}>Save</Button>}
                        <Link to="/pages/compare-scenes">
                            <Button>Back</Button>
                        </Link>
                    </div>

                </LoadingCover>
            </div>
        );

    }
}

export default Form.create()(abortAjaxHoc(withRouter(CompareForm)));



// WEBPACK FOOTER //
// ./src/pages/CompareScenes/CompareForm.js